"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.composeAnalytics = composeAnalytics;
exports.composeEvent = composeEvent;
function composeAnalytics(events) {
  return {
    events: events
  };
}

function composeEvent(name, payload) {
  return {
    event: name,
    payload: payload
  };
}

exports.default = {
  composeAnalytics: composeAnalytics,
  composeEvent: composeEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/compose.js
// module id = 67
// module chunks = 1